import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/scss/vuetify/overrides.scss";
Vue.use(Vuetify);

// Paleta Konnekta Capital Humano
// - colorDark    (azul navy)        : #1e3a8a  — lupa y titulo KONNEKTA
// - colorBright  (azul vivo)        : #2563eb  — persona y "CAPITAL HUMANO"
// - colorGreen   (verde check)      : #10b981  — palomita del logo
const theme = {
  primary: "#1e3a8a",
  secondary: "#2563eb",
  info: "#2563eb",
  success: "#10b981",
  accent: "#2563eb",
  warning: "#f59e0b",
  error: "#ef4444",
  default: "#1e3a8a",
};

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: false,
  },
  rtl: false,
});
